(function () {
  class DynamicCheckoutLabel {
    constructor(checkout) {
      this.checkout = checkout;
      this.form = checkout.closest("form");
      this.scope =
        checkout.closest('[id^="MainProduct-"], .featured-product, .shopify-section') ||
        document;
      this.oneTimeLabel = (checkout.dataset.oneTimeLabel || "").trim();
      this.subscriptionLabel = (checkout.dataset.subscriptionLabel || "").trim();

      if (!this.oneTimeLabel || !this.subscriptionLabel) return;

      this.updateQueued = false;
      this.handleFormChange = this.handleFormChange.bind(this);
      this.handleMutation = this.handleMutation.bind(this);
      this.scheduleUpdate = this.scheduleUpdate.bind(this);

      this.mount();
    }

    mount() {
      this.scope.addEventListener("change", this.handleFormChange, true);
      this.scope.addEventListener("input", this.handleFormChange, true);
      this.scope.addEventListener("click", this.handleFormChange, true);

      this.checkoutObserver = new MutationObserver(this.handleMutation);
      this.checkoutObserver.observe(this.checkout, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      this.scopeObserver = new MutationObserver(this.handleMutation);
      this.scopeObserver.observe(this.scope, {
        childList: true,
        subtree: true,
      });

      this.updateButtonLabel();
    }

    handleFormChange() {
      this.scheduleUpdate();
    }

    handleMutation() {
      this.scheduleUpdate();
    }

    scheduleUpdate() {
      if (this.updateQueued) return;
      this.updateQueued = true;
      window.requestAnimationFrame(() => {
        this.updateQueued = false;
        this.updateButtonLabel();
      });
    }

    getSellingPlanValue(scope) {
      const checkedSellingPlanInput = scope.querySelector(
        'input[name*="selling_plan"]:checked',
      );
      if (checkedSellingPlanInput) {
        return (checkedSellingPlanInput.value || "").trim();
      }

      const sellingPlanSelect = scope.querySelector('select[name*="selling_plan"]');
      if (sellingPlanSelect) {
        return (sellingPlanSelect.value || "").trim();
      }

      const hiddenSellingPlanInput = scope.querySelector(
        'input[name*="selling_plan"]',
      );
      if (hiddenSellingPlanInput) {
        return (hiddenSellingPlanInput.value || "").trim();
      }

      return "";
    }

    normalizeText(text) {
      return String(text || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    }

    getPurchaseContext(scope) {
      const candidates = scope.querySelectorAll(
        [
          'input[name*="selling_plan"]:checked',
          'input[id*="selling_plan"]:checked',
          'select[name*="selling_plan"]',
          'input[name*="purchase"]:checked',
          'input[name*="delivery"]:checked',
          '[class*="selling-plan"] input[type="radio"]:checked',
          '[class*="subscription"] input[type="radio"]:checked',
          '[data-selling-plan] input[type="radio"]:checked',
          '[data-purchase-option] input[type="radio"]:checked',
        ].join(", "),
      );

      const context = [];
      candidates.forEach((element) => {
        const label = element.closest("label");
        const wrapper = element.closest(
          '[class*="selling-plan"], [class*="subscription"], [data-selling-plan], [data-purchase-option]',
        );
        context.push(
          element.value,
          element.dataset.purchaseOption,
          element.dataset.optionType,
          element.getAttribute("aria-label"),
          label ? label.textContent : "",
          wrapper ? wrapper.textContent : "",
        );
      });

      return this.normalizeText(context.filter(Boolean).join(" "));
    }

    isSubscriptionSelected() {
      const scopes = [this.form, this.scope, document].filter(Boolean);

      for (let index = 0; index < scopes.length; index += 1) {
        const sellingPlanValue = this.getSellingPlanValue(scopes[index]);
        if (sellingPlanValue !== "" && sellingPlanValue !== "0") {
          return true;
        }
      }

      const contextText = this.getPurchaseContext(this.scope);
      if (!contextText) {
        return false;
      }

      if (
        contextText.includes("suscrip") ||
        contextText.includes("subscription") ||
        contextText.includes("recurr") ||
        contextText.includes("mensual") ||
        contextText.includes("monthly") ||
        contextText.includes("cada mes") ||
        contextText.includes("anual") ||
        contextText.includes("annual")
      ) {
        return true;
      }

      if (
        contextText.includes("one time") ||
        contextText.includes("one-time") ||
        contextText.includes("una vez") ||
        contextText.includes("pago unico") ||
        contextText.includes("pago de una vez") ||
        contextText.includes("pago unicamente") ||
        contextText.includes("unico") ||
        contextText.includes("single")
      ) {
        return false;
      }

      return false;
    }

    setButtonLabel(button, label) {
      if (!button || !label) return;

      if (button.getAttribute("aria-label") !== label) {
        button.setAttribute("aria-label", label);
      }

      const textNode = button.querySelector("span");
      if (textNode) {
        if (textNode.textContent === label) return;
        textNode.textContent = label;
        return;
      }

      if (button.textContent.trim() === label) return;
      button.textContent = label;
    }

    updateButtonLabel() {
      const targetLabel = this.isSubscriptionSelected()
        ? this.subscriptionLabel
        : this.oneTimeLabel;

      const unbrandedButton = this.checkout.querySelector(
        ".shopify-payment-button__button--unbranded",
      );

      if (unbrandedButton) {
        this.setButtonLabel(unbrandedButton, targetLabel);
      }
    }
  }

  function initDynamicCheckoutLabel(scope) {
    const root = scope || document;
    const checkouts = root.querySelectorAll(
      '.product-form__checkout[data-dynamic-checkout-text="true"]',
    );

    checkouts.forEach((checkout) => {
      if (checkout.dataset.dynamicCheckoutMounted === "true") return;
      checkout.dataset.dynamicCheckoutMounted = "true";
      new DynamicCheckoutLabel(checkout);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initDynamicCheckoutLabel(document);
    });
  } else {
    initDynamicCheckoutLabel(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initDynamicCheckoutLabel(event.target);
  });
})();
